import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Container } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import ColumnChart from "./components/charts/ColumnChart";
import AddNewCardForm from "./pages/cards/AddNewCardForm";
console.log("checking git push 2");
const Test = () => {
  const bull = (
    <Box
      component="span"
      sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
    >
      •
    </Box>
  );
  return (
    <>
      <AddNewCardForm />
    </>
    // <div>
    //   {" "}
    //     <ColumnChart />
    //   <Container>
    //     <Card sx={{ minWidth: 275 }}>
    //       <CardContent>
    //         <Typography
    //           sx={{ fontSize: 14 }}
    //           color="text.secondary"
    //           gutterBottom
    //         >
    //           Word of the Day
    //         </Typography>
    //         <Typography variant="h5" component="div">
    //           be{bull}nev{bull}o{bull}lent
    //         </Typography>
    //         <Typography sx={{ mb: 1.5 }} color="text.secondary">
    //           adjective
    //         </Typography>
    //         <Typography variant="xsmall">
    //           well meaning and kindly.
    //           <br />
    //           {'"a benevolent smile"'}
    //         </Typography>
    //       </CardContent>
    //       <CardActions>
    //         <Button size="small">Learn More</Button>
    //       </CardActions>
    //     </Card>
    //     <Box sx={{ width: "100%", maxWidth: 500 }}>
    //       <Typography variant="h1" gutterBottom>
    //         h1. Heading
    //       </Typography>
    //       <Typography variant="h2" gutterBottom>
    //         h2. Heading
    //       </Typography>
    //       <Typography variant="h3" gutterBottom>
    //         h3. Heading
    //       </Typography>
    //       <Typography variant="h4" gutterBottom>
    //         h4. Heading
    //       </Typography>
    //       <Typography variant="h5" gutterBottom>
    //         h5. Heading
    //       </Typography>
    //       <Typography variant="h6" gutterBottom>
    //         h6. Heading
    //       </Typography>
    //       <Typography variant="base" gutterBottom>
    //         base. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos
    //         blanditiis tenetur
    //       </Typography>
    //       <Typography variant="medium" gutterBottom>
    //         medium. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
    //         Quos blanditiis tenetur
    //       </Typography>
    //       <Typography variant="small" gutterBottom>
    //         small. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
    //         Quos blanditiis tenetur unde suscipit, quam beatae rerum inventore
    //         consectetur, neque doloribus, cupiditate numquam dignissimos laborum
    //         fugiat deleniti? Eum quasi quidem quibusdam.
    //       </Typography>
    //       <Typography variant="xsmall" gutterBottom>
    //         xsmall. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
    //         Quos blanditiis tenetur unde suscipit, quam beatae rerum inventore
    //         consectetur, neque doloribus, cupiditate numquam dignissimos laborum
    //         fugiat deleniti? Eum quasi quidem quibusdam.
    //       </Typography>
    //       <Typography variant="button" display="block" gutterBottom>
    //         button text
    //       </Typography>
    //       <Typography variant="xxsmall" display="block" gutterBottom>
    //         xxsmall text
    //       </Typography>
    //       <Typography variant="overline" display="block" gutterBottom>
    //         overline text asddasd
    //       </Typography>
    //       <Typography variant="poster" display="block" gutterBottom>
    //         overline text poster
    //       </Typography>
    //     </Box>
    //   </Container>

    // </div>
  );
};

export default Test;
